// extracted by mini-css-extract-plugin
module.exports = {"comp":"TabSwiperA_comp__creFy"};